module.exports = __webpack_public_path__ + "static/media/search-personalization-conversion-rate.f0797410.png";